import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsReferrerPayoutProps } from "./types";
import { messages } from "./messages";
import dayjs from "dayjs";

export const HistoryDetailsReferrerPayout: React.FC<
  HistoryDetailsReferrerPayoutProps
> = ({ data: deposit }) => {
  const { formatMessage } = useIntl();
  const getStatus = () => {
    const stClass = "text-[--color-success]";
    const st = formatMessage(messages.approved);
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField
        label={formatMessage(messages.earned)}
        value={deposit.amount + " " + deposit.ticker_id.toUpperCase()}
      />
      <DetailsField
        label={formatMessage(messages.date)}
        value={dayjs(deposit.date).format("DD.MM.YYYY")}
      />
      <DetailsField
        label={formatMessage(messages.status)}
        value={getStatus()}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={deposit.tid ?? ""}
        copy
      />
    </div>
  );
};
